import axios from "fetch-api/fetch-api";
import { IGoogleReviewSummary } from "./interfaces/google-reviews.type";

export function getGoogleReviewSummary() {
  return axios.get<IGoogleReviewSummary>("s/get-google-review-summary");
}
